import { FormFieldTypes } from "../../../../data/formFieldType";

export const CertificateCorporateListdata = {
  name: "AdditionalInfo",
  initialState: {
    companyNameOrUen: '',
    haveapplications: null,
    haveCertifications: null,
  },
  formFields: [
    {
      id: "companyNameOrUen",
      lable: "Company Name/UEN",
      Field_Name: "Company Name/UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyNameOrUen",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "haveapplications",
      lable: "Have applications",
      Field_Name: "Have applications",
      fieldType: FormFieldTypes.SELECT,
      dataField: "haveapplications",
      fieldSetting: {
        placeholder: "",
        options: [
          { value: 1, label: "Product" },
          { value: 2, label: "Service" },
          { value: 3, label: "Both" }
        ],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "haveCertifications",
      lable: "Have certifications",
      Field_Name: "Have certifications",
      fieldType: FormFieldTypes.SELECT,
      dataField: "haveCertifications",
      fieldSetting: {
        placeholder: "",
        options: [
          { value: 1, label: "Product" },
          { value: 2, label: "Service" },
          { value: 3, label: "Both" }
        ],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
